import { Controller } from "@hotwired/stimulus";

export default class PreventCurrentPageController extends Controller {
  prevent(event) {
    const currentPath = globalThis.location.pathname;
    const linkPath = new URL(this.element.href).pathname;

    if (currentPath === linkPath) {
      event.preventDefault();
    }
  }
}
